$(document).on('click', '.js-counterMinus', (event) => {
  const _this = $(event.currentTarget)
  const count = _this.parents('.js-counter')
  const input = count.find('.js-counterInput')

  event.preventDefault()

  if (input.val() <= 1) return false

  input.val(parseFloat(input.val()) - 1).trigger('change')
})

$(document).on('click', '.js-counterPlus', (event) => {
  const _this = $(event.currentTarget)
  const count = _this.parents('.js-counter')
  const input = count.find('.js-counterInput')
  const inputVal = input.val() || 0

  event.preventDefault()

  input.val(parseFloat(inputVal) + 1).trigger('change')
})
